import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetBlogResponse, FilterResponseItem, IBlogQueryParams } from "../../interfaces/types";

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: `/foundation-api/blog/`
    }),
    endpoints(builder) {
        return {
            getArticleItems: builder.query<GetBlogResponse, IBlogQueryParams>({
                query: (params) => {
                    const qs = new URLSearchParams();
                    if (params.searchText) qs.set('searchText', params.searchText);
                    params.categories.forEach(c => qs.append('categories', c));
                    params.publishDates.forEach(d => qs.append('publishDates', d));
                    qs.set('pageNumber', String(params.pageNumber));
                    qs.set('pageSize', String(params.pageSize));
                    return `GetItems?${qs.toString()}`;
                }
            }),
            getFilters: builder.query<FilterResponseItem[], void>({
                query: () => `GetFilters`
            })
        };
    },
});

export const { useGetArticleItemsQuery, useGetFiltersQuery } = apiSlice;